import { Send } from '@/components/icons/Send';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '@/components/ui/tooltip';
import { Translator } from 'components/i18n';
import { useUISettings } from '@/hooks/useUISettings';

interface SubmitButtonProps {
  disabled?: boolean;
  onSubmit: () => void;
}

export default function SubmitButton({
  disabled,
  onSubmit
}: SubmitButtonProps) {
  const { settings } = useUISettings();
  const buttonBg = settings?.colors?.submitButtonBackground || '#152644';
  
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            id="chat-submit"
            disabled={disabled}
            onClick={onSubmit}
            size="icon"
            style={{ backgroundColor: buttonBg }}
            className="rounded-full h-8 w-8 min-h-[32px] min-w-[32px] hover:opacity-90 flex-shrink-0"
          >
            <Send className="!size-6" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            <Translator path="chat.input.actions.send" />
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
